<div class="cell-wrapper">
  @if (collateralsToDisplay?.nonCash && locateMatch?.nonCashMatch) {
  <ng-container *ngTemplateOutlet="actionsTpl; context: { $implicit: locateMatch.nonCashMatch}"></ng-container>
  } @if (collateralsToDisplay?.cash && locateMatch?.cashMatch) {
  <ng-container *ngTemplateOutlet="actionsTpl; context: { $implicit: locateMatch.cashMatch}"></ng-container>
  }
</div>
<ng-template #actionsTpl let-collateralSpecificMatch>
  @if (collateralSpecificMatch.form.enabled) {
  <sg-borrow-rate-request-button
    class="sg-button-full-width"
    [isOperationInProgress$]="tracker.busy$"
    [isBorrow]="collateralSpecificMatch.form.controls.rate.value === collateralSpecificMatch.form.controls.rate.defaultValue"
    (onclick)="onClick.emit({ collateralSpecificMatch, action: $event })"></sg-borrow-rate-request-button>
  } @else {
  <div class="sg-in-review-label" data-test="sg-in-review-label">
    <mat-icon>schedule</mat-icon>
    <span>In Review</span>
  </div>
  }
</ng-template>
